import { getProfilePageSchema } from '@domain/seo/schema';
import { JsonLd } from '../../../../components/JsonLd/JsonLd';

interface IProps {
  fullName: string;
  nickname: string;
  avatarUrl: string;
}

export const AnglerSchema = ({ fullName, nickname, avatarUrl }: IProps) => {
  const anglerSchema = getProfilePageSchema({ fullName, nickname, avatarUrl });
  return <JsonLd schema={anglerSchema} />;
};
